import React from "react";
import "./PrivacyPolicy.scss";

const sections = [
  {
    id: "introduction",
    title: "1. Introduction",
    content: (
      <p>
        This Privacy Policy outlines how we collect, use, disclose, and
        safeguard your information when you use our Safety SaaS application. By
        using our platform, you agree to the collection and use of information
        in accordance with this policy.
      </p>
    ),
  },
  {
    id: "information-we-collect",
    title: "2. Information We Collect",
    content: (
      <ul>
        <li>
          Personal identification information (e.g., name, email address, phone
          number)
        </li>
        <li>Company details</li>
        <li>
          Usage data (e.g., log files, IP address, browser type, device type)
        </li>
        <li>Location data (if permission is granted)</li>
        <li>Health and safety incident reports</li>
      </ul>
    ),
  },
  {
    id: "how-we-use-information",
    title: "3. How We Use Information",
    content: (
      <ul>
        <li>To operate and maintain our services</li>
        <li>To improve user experience and product functionality</li>
        <li>To communicate with users (e.g., support, service updates)</li>
        <li>To ensure legal compliance and protect our legal rights</li>
      </ul>
    ),
  },
  {
    id: "sharing-of-information",
    title: "4. Sharing of Information",
    content: (
      <ul>
        <li>
          With service providers who help operate our platform (under strict
          confidentiality agreements)
        </li>
        <li>To comply with legal obligations or respond to lawful requests</li>
        <li>
          In connection with business transfers (e.g., mergers, acquisitions)
        </li>
      </ul>
    ),
  },
  {
    id: "data-security",
    title: "5. Data Security",
    content: (
      <p>
        We implement reasonable technical and organizational measures to protect
        your data. However, no method of transmission over the internet or
        electronic storage is 100% secure.
      </p>
    ),
  },
  {
    id: "user-rights",
    title: "6. User Rights",
    content: (
      <ul>
        <li>
          You have the right to access, correct, or delete your personal data.
        </li>
        <li>
          You may withdraw your consent at any time where processing is based on
          consent.
        </li>
      </ul>
    ),
  },
  {
    id: "data-retention",
    title: "7. Data Retention",
    content: (
      <p>
        We retain personal information for as long as necessary to fulfill the
        purposes outlined in this policy, unless a longer retention period is
        required or permitted by law.
      </p>
    ),
  },
  {
    id: "third-party-services",
    title: "8. Third-Party Services",
    content: (
      <p>
        We may use third-party services (e.g., analytics tools, cloud providers)
        that collect, monitor, and analyze usage. These third parties are
        governed by their own privacy policies.
      </p>
    ),
  },
  {
    id: "international-data",
    title: "9. International Data Transfers",
    content: (
      <p>
        Our services are operated in Canada. If you access our services from
        outside Canada, your information may be transferred to, stored, and
        processed in Canada or other countries.
      </p>
    ),
  },

  {
    id: "changes",
    title: "10. Changes to This Privacy Policy",
    content: (
      <p>
        We may update this Privacy Policy from time to time. We will notify
        users of significant changes and revise the "Last Updated" date at the
        top of the policy.
      </p>
    ),
  },
  {
    id: "contact",
    title: "11. Contact Us",
    content: (
      <p>
        If you have questions or concerns about this Privacy Policy, please
        contact us at:{" "}
        <a href="mailto:sales@alpacasys.com">sales@alpacasys.com</a>
      </p>
    ),
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: August 26, 2025</p>

      <div className="toc">
        <h2>Table of Contents</h2>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.title}</a>
            </li>
          ))}
        </ul>
      </div>

      {sections.map((section) => (
        <div key={section.id} id={section.id} className="privacySectionBlock">
          <h3 className="sectionTitle">{section.title}</h3>
          <div className="section-content">{section.content}</div>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
